var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('HeaderMain'),_vm._v(" "),_c('Banner'),_vm._v(" "),_c('Benefits'),_vm._v(" "),_c('TopCourses'),_vm._v(" "),_c('Count'),_vm._v(" "),_c('TopInstructors'),_vm._v(" "),_c('Reviews'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fa81a89","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage/index.vue
// module id = null
// module chunks = 